import { Box, Button, Group, Stack, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import CompanyWrapper from 'src/company/templates/components/CompanyWrapper';
import ExportAssetsContent from './ExportAssetsContent';
import { useBackpopulateAllBranding } from './hooks/useExportBranding';

export default function ExportAssetsTab() {
  const { backpopulateAll, isLoading } = useBackpopulateAllBranding();

  const handleBackpopulate = async () => {
    try {
      const result = await backpopulateAll();
      const data = result?.data;
      if (!data) return;

      notifications.show({
        title: 'Branding back-populated',
        message: `Populated ${data.populated} tenant(s), skipped ${data.skipped}.`,
        color: 'green',
      });

      for (const err of data.errors) {
        notifications.show({
          title: `Failed: ${err.tenantName}`,
          message: err.error,
          color: 'red',
          autoClose: false,
        });
      }
    } catch {
      notifications.show({
        title: 'Back-populate failed',
        message: 'Failed to back-populate branding for all tenants.',
        color: 'red',
      });
    }
  };

  return (
    <Stack gap="md">
      <Box p="md" bg="white">
        <Group justify="space-between" align="center">
          <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.6">
            Parse existing export_assets.docx files and create branding configs for all tenants that
            don&apos;t have one yet.
          </Text>
          <Button onClick={handleBackpopulate} loading={isLoading} variant="light" color="orange">
            Backpopulate All Tenants
          </Button>
        </Group>
      </Box>
      <CompanyWrapper contentComponent={ExportAssetsContent} />
    </Stack>
  );
}
